export default "/images/Event1.png?ded5812d350bd67f27eeef2f9e6b30d4";